module.exports = __webpack_public_path__ + "img/Rectangle 139.10e0cde4.png";